// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".canvas\\:\\:editor-admin-Gallery .blocks button svg{height:100%;margin-left:auto;margin-right:auto;width:auto}", "",{"version":3,"sources":["<no source>"],"names":[],"mappings":"AAAA,mDAAA,WAAA,CAAA,gBAAA,CAAA,iBAAA,CAAA,UAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
